import React from 'react';
import Input from "../Input-new/Input";
import PropTypes from "prop-types";
import Dropdown from "../Dropdown/Dropdown";
import Control from "../Control";

const RoverForm = ({theme = 'white', width, data, paneIndex, isFilter = false, handleSubmit, handleCancel, handleParentChange, handleParentDropdownChange, handlePaneChange}) => {
    const panes = [
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>{isFilter ? 'Rover' : 'Add Rover'}</div>
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='name'
                       label='Name'
                       value={data.name}
                       required={!isFilter}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='address'
                       label='Address'
                       value={data.address}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='city'
                       label='City'
                       value={data.city}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType={isFilter ? 'text' : 'email'}
                       name='email'
                       label='Email'
                       value={data.email}
                       handleParentChange={handleParentChange}
                />
                <div className='form-address'>
                    <div className='form-state'>
                        <Dropdown theme={theme}
                                  width={width}
                                  name='state'
                                  label='State'
                                  value={data.state}
                                  options={[
                                      {value: 'TX', label: 'Texas'},
                                      {value: 'CA', label: 'California'},
                                      {value: 'NY', label: 'New York'},
                                      {value: 'FL', label: 'Florida'},
                                      {value: 'IL', label: 'Illinois'},
                                      {value: 'PA', label: 'Pennsylvania'},
                                      {value: 'OH', label: 'Ohio'},
                                      {value: 'GA', label: 'Georgia'},
                                      {value: 'NC', label: 'North Carolina'},
                                      {value: 'MI', label: 'Michigan'}
                                  ]}
                                  handleParentDropdownChange={handleParentDropdownChange}
                        />
                    </div>
                    <div className='form-zip'>
                        <Input theme={theme}
                               width={width}
                               valueType='text'
                               name='zip'
                               label='Zip'
                               value={data.zip}
                               handleParentChange={handleParentChange}
                        />
                    </div>
                </div>
                <Input theme={theme}
                       width={width}
                       valueType='phone'
                       name='phone'
                       label='Phone'
                       value={data.phone}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='website'
                       label='Website'
                       value={data.website}
                       handleParentChange={handleParentChange}
                />
            </React.Fragment>
        ),
    ];

    return (
        <form className='form' onSubmit={handleSubmit}>
            <div className='form-slider'>
                {
                    panes.map((el, key) => (
                        <Control key={key} onClick={()=> handlePaneChange(key)}>
                            <div className={`form-slider-icon ${theme}${key === paneIndex ? ' active' : ''}`}/>
                        </Control>
                    ))
                }
            </div>
            {
                panes[paneIndex]
            }
            {
                isFilter ?
                    <div className='filter-buttons'>
                        <button type='button' className='button-new negative dark' onClick={handleCancel}>Clear</button>
                        <button className='button-new positive'>Apply</button>
                    </div>
                    :
                    <React.Fragment>
                        <button type='button' className='button-new negative' onClick={handleCancel}>Cancel</button>
                        <button className='button-new positive'>Submit</button>
                    </React.Fragment>
            }
        </form>
    )
};

RoverForm.propTypes = {
    theme: PropTypes.oneOf(['white', 'dark']),
    width: PropTypes.string,
    data: PropTypes.object,
    paneIndex: PropTypes.number,
    isFilter: PropTypes.bool,
    handleSubmit: PropTypes.func,
    handleCancel: PropTypes.func,
    handleParentChange: PropTypes.func,
    handleParentDropdownChange: PropTypes.func,
    handlePaneChange: PropTypes.func
};

export default RoverForm;
